import { render } from "./TikTokLeads.vue?vue&type=template&id=a3e4e4b2"
import script from "./TikTokLeads.vue?vue&type=script&lang=js"
export * from "./TikTokLeads.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__